import { ApplicationState, AppThunkDispatch } from "../../store";
import { connect } from "react-redux";
import ProfessionalForm  from "../../components/Forms/ProfessionalForm";
import { getMyUser } from "../../store/session/selectors";
import { PermissionEnum } from "../../models";
import { ProfessionalEntity } from "../../store/entities/state";
import { getEntity, isSubmitting, getChangeLog, getChangingValue, getChangingState } from "../../store/entities/selectors";
import { entityEditionCancel, updateEntity, loadEntityChangeLog, updateChangingEntity, loadEntities, deleteEntity } from "../../store/entities/actions";
import { updateProfessionalAsync, getProfessionalChangeLogAsync, getProfessionalAsync, deleteProfessionalAsync } from "../../ajax/requests";
import { ProfessionalFormDispatchProps, ProfessionalFormStateProps } from "../../components/Forms/ProfessionalForm/ProfessionalForm";

const canEdit = (state: ApplicationState) => getMyUser(state)?.permissions.some(p => p === PermissionEnum.Administrator || p === PermissionEnum.ProfessionalsManagement) || false;

export interface ProfessionalFormProps {
    data: ProfessionalEntity,
    onClose?: () => void,
}

const mapStateToProps = (state: ApplicationState, ownProps: ProfessionalFormProps): ProfessionalFormStateProps => ({
    type: 'edit',
    canEdit: canEdit(state),
    data: (getChangingValue(state, 'professionals') as ProfessionalEntity)
        || getEntity(state, 'professionals', ownProps.data.id)
        || ownProps.data,
    hasChanged: getChangingState(state, 'professionals'),
    isSubmitting: isSubmitting('professionals')(state),
    changeLog: getChangeLog(state, 'professionals', ownProps.data.id),
})

const mapDispatchToProps = (dispatch: AppThunkDispatch, ownProps: ProfessionalFormProps): ProfessionalFormDispatchProps => ({
    onChange: (data: ProfessionalEntity) => dispatch(updateChangingEntity('professionals', data)),
    onCancel: () => {
        dispatch(entityEditionCancel('professionals'));
        ownProps.onClose && ownProps.onClose();
    },
    onSave: (data: ProfessionalEntity) => {
        dispatch(updateEntity('professionals', data, c => updateProfessionalAsync(c.id, c)))
            .then(_ => {
                // Only close if update was successful
                ownProps.onClose && ownProps.onClose();
            })
            .catch(error => {
                // Error is already handled by updateEntity action, just prevent closing
                console.error('Failed to update professional:', error);
            });
    },
    onDelete: () => {
        dispatch(deleteEntity('professionals', ownProps.data.id, () => deleteProfessionalAsync(ownProps.data.id)))
            .then(_ => {
                ownProps.onClose && ownProps.onClose();
            })
            .catch(error => {
                console.error('Failed to delete professional:', error);
            });
    },
    onLoad: () => {
        dispatch(loadEntities('professionals', () => getProfessionalAsync(ownProps.data.id), 'AppendResult'))
        dispatch(loadEntityChangeLog('professionals', ownProps.data.id, () => getProfessionalChangeLogAsync(ownProps.data.id)));
    },
});

export default connect<ProfessionalFormStateProps, ProfessionalFormDispatchProps, ProfessionalFormProps, ApplicationState>(
    mapStateToProps,
    mapDispatchToProps,
)(ProfessionalForm as any);
